import React from "react"

export default function Navbar(props) {
  return (
    <div className="links navbar">
      <h3 className="main-button" id="update" onClick={props.onClick2}>Refresh</h3>
      <h3 className="main-button about" id="about" onClick={props.onClick}>{props.page === "container" ? "About" : ""}</h3>
    </div>
  );
}
